import styled, { css } from 'styled-components'

import { themeStyles } from '../../../styles/theme'
import HideBalanceIcon from '../../../images/icon_hidebalance.svg'
import ShowBalanceIcon from '../../../images/icon_showbalance.svg'
import ArrowDownIcon from '../../../images/arrow_down_icon.svg'

export const StyledWrapper = styled.div`
  line-height: 35px;
  display: flex;
  align-items: center;

  a {
    cursor: pointer;
  }
`

export const StyledUserName = styled.div`
  color: ${themeStyles.colors.accentColors.secondary.main};
`

export const StyledBalanceToggle = styled.button`
  width: 28px;
  height: 35px;
  margin: 0 0.5rem;
  outline: none;
  background: url(${HideBalanceIcon}) 50% no-repeat;

  &.active {
    background: url(${ShowBalanceIcon}) 50% no-repeat;
  }
`

export const StyledMenuToggle = styled.button`
  width: 16px;
  height: 35px;
  outline: none;
  background: url(${ArrowDownIcon}) 50% no-repeat;
  background-size: contain;
`
export const StyledMobileWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 1000px;
  padding: 8px;
  padding-right: 11px;
  background: ${themeStyles.colors.dominantGrey.main};

  @media (max-width: 320px) {
    ${({ isShowingBalance }) =>
      !isShowingBalance &&
      css`
        gap: 0px;
      `}
  }
`
